const RevenueSpendListTableLangKey = [
	'column_id',
	'column_date',
	'column_date_updated',
	'column_amount',
	'column_account_id',
	'column_account',
	'column_account_in_group',
	'column_kt_group',
	'column_agency_id',
	'column_agency',
	'column_history',
	'column_notes'
] as const

type IRevenueSpendListTableLangKey = typeof RevenueSpendListTableLangKey[number]

export type IRevenueSpendListTableLang = {
	revenue_spend_list_table: Record<IRevenueSpendListTableLangKey, string>
}

const langEntries = RevenueSpendListTableLangKey.map(
	(key: IRevenueSpendListTableLangKey) => [key, `revenue_spend_list_table.${key}`]
)

const langObj: Record<IRevenueSpendListTableLangKey, string> = Object.fromEntries(langEntries)

export const REVENUE_SPEND_LIST_TABLE_LANG_KEY: IRevenueSpendListTableLang = {
	revenue_spend_list_table: langObj
}
